<template>
    <div>
        <p class="font-semibold text-2xl text-yellow-400" >
            - {{datanya.nama}}
        </p>
        <p class="font-semibold text-2xl text-white ml-5" v-html="datanya.title">
        </p>
        <p class="font-semibold text-lg text-white ml-5" v-html="datanya.tentang">
        </p>
        <hr>
        <p class="text-white font-semibold text-lg italic underline">PENGALAMAN KERJA</p>
        <div v-for="(item, index) in pengalaman" :key="index+'pengalaman'" class="text-white text-lg">
            <div class="row">
                <div class="col-4">
                    {{item.lama_kerja}}
                </div>
                <div class="col-8">
                        {{item.posisi}} <br>
                        {{item.tempat_kerja}}
                </div>
            </div>
        </div>
        <hr>
         <p class="text-white font-semibold text-lg italic underline">PENDIDIKAN</p>
        <div v-for="(item, index) in pendidikan" :key="index+'pengalaman'" class="text-white text-lg">
            <div class="row">
                <div class="col-4">
                    {{item.lama_pendidikan}}
                </div>
                <div class="col-8">
                        {{item.pendidikan}} <br>
                        {{item.sekolah}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import autophp from '@/plugins/autophp';
let sdb = new autophp();
let urlnya="https://gis.officialapp.my.id";
export default{
    layout:'a-2',
    data(){
        return{
            datanya:[],
            pengalaman:[],
            pendidikan:[]
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(){
            sdb.collection("app_portofolio_about",false,urlnya).doc().select(`select * from app_portofolio_about where iduser='${this.$store.state.id}'`).then(res => {
                this.datanya=res[0];
                this.$forceUpdate();
            });
             sdb.collection("app_portofolio_pendidikan",false,urlnya).doc().select(`select * from app_portofolio_pendidikan where iduser='${this.$store.state.id}'`).then(res => {
                this.pendidikan=res;
                this.$forceUpdate();
            });
            sdb.collection("app_portofolio_pengalaman",false,urlnya).doc().select(`select * from app_portofolio_pengalaman where iduser='${this.$store.state.id}'`).then(res => {
                this.pengalaman=res;
                this.$forceUpdate();
            });
            
        },
        test(){
            sdb.collection("app_portofolio_about",false,urlnya).doc().select(`select * from app_portofolio_about where iduser='${this.$store.state.id}'`).then(res => {
                console.log(res);
            });
        }
    },
}
</script>